export class DialogMessageData {

    public header: string;

    public message?: string;

    public messages?: string[];

    public width? = '20vw';
}
